export default __webpack_public_path__ + "static/media/hero-img.dd8d9f3a.png";